import { render, staticRenderFns } from "./dynamic-document-font-configuration-template.vue?vue&type=template&id=58743b5b&scoped=true&"
import script from "./dynamic-document-font-configuration-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-font-configuration-template.vue?vue&type=script&lang=ts&"
import style0 from "./dynamic-document-font-configuration-template.vue?vue&type=style&index=0&id=58743b5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58743b5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
